export default {
  getCustomerLocationTime: (state) => state.customerLocationTime,
};
